<template>
  <div class="row">
    <div class="mx-auto col-md-12">
      <div class="card p-3 mb-3">
        <div class="card-body">
          <b-card class="mb-3" header="Pagamentos">
            <b-card no-body>
              <b-table
                no-provider-paging
                small
                bordered
                responsive
                :current-page="tabela.currentPage"
                :empty-text="tabela.emptyText"
                :fields="tabela.fields"
                :items="tabela.items"
                :per-page="tabela.perPage"
                :show-empty="tabela.showEmpty"
                :striped="tabela.striped"
              >
                <template v-slot:cell(valor_total_beneficio)="data">
                  {{ formatNumero(data.item.valor_total_beneficio) }}
                </template>
                <template v-slot:cell(acoes)="data">
                  <b-button
                    variant="primary"
                    size="sm"
                    style="font-size: 12px"
                    @click.prevent="gerarEnviarArquivo(data.item)"
                    v-if="
                      $store.getters.userRoles.includes(
                        $constantes.usuario.ROLES.SUPERADMINISTRADOR
                      )
                    "
                    title="Gerar/Enviar Arquivo"
                  >
                    <font-awesome-icon
                      :icon="['fas', 'share-square']"
                      class="mr-1"
                    />Gerar/Enviar Arquivo
                  </b-button>
                </template>
              </b-table>
              <b-card-footer size="sm">
                <div class="float-left">
                  <b-input-group prepend="Quantidade de Registros">
                    <b-input disabled :value="tabela.items.length"></b-input>
                  </b-input-group>
                </div>
                <div class="float-right">
                  <b-pagination
                    align="right"
                    :total-rows="tabela.totalRows"
                    v-model="tabela.currentPage"
                    :per-page="tabela.perPage"
                  >
                  </b-pagination>
                </div>
              </b-card-footer>
            </b-card>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabela: {
        currentPage: 1,
        items: [],
        fields: [
          {
            key: "mes_referencia",
            label: "Mês",
            class: "text-center",
          },
          {
            key: "ano_referencia",
            label: "Ano",
            class: "text-center",
          },
          {
            key: "conta",
            label: "Conta",
            class: "text-center",
            thStyle: "width:180px",
          },
          {
            key: "nome_beneficio",
            label: "Benefício",
            class: "text-center",
          },
          {
            key: "valor_total_beneficio",
            label: "Valor Total Benefício",
            class: "text-center",
          },
          {
            key: "acoes",
            label: "",
            class: "text-center",
            thStyle: "width:180px",
          },
        ],
        showEmpty: true,
        emptyText: "Nenhum registro encontrado",
        striped: true,
        perPage: 12,
        totalRows: 0,
      },
    };
  },

  methods: {
    formatNumero(valor) {
      return parseInt(valor).toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
      });
    },

    gerarEnviarArquivo(item) {
      this.$helpers
        .modalConfirmacao(
          this,
          "Gerar/Enviar Arquivo",
          'Deseja realmente gerar/enviar o arquivo de pagamento do benefício "' +
            item.nome_beneficio +
            '" do mês "' +
            item.mes_referencia +
            '" e ano "' +
            item.ano_referencia +
            '"?',
          "primary",
          "SIM"
        )
        .then((value) => {
          if (value) {
            this.$api
              .post(`pagamentos/gerar-enviar-pagamento`, item)
              .then((response) => {
                if (response.status == 200) {
                  this.tabela.items = [];
                  response.data.dados.forEach((element) => {
                    element.conta =
                      element.numero_conta + " - " + element.descricao_conta;
                    this.tabela.items.push(element);
                  });
                  this.tabela.totalRows = response.data.dados.length;
                  this.tabela.currentPage = 1;
                  this.$helpers.showToast(
                    this,
                    "Sucesso",
                    response.data.message,
                    "success"
                  );
                }
              })
              .catch((error) => {
                if (error.response.data && error.response.data.code != 1) {
                  let msgErro =
                    "Erro na geração do arquivo.Favor entrar em contato com o Analista responsável." +
                    "[Erro:" +
                    error.response.data.message +
                    "]";
                  this.$helpers.showToast(this, "Erro", msgErro, "danger");
                } else {
                  this.$helpers.showToast(
                    this,
                    "Erro",
                    error.response.data.message,
                    "danger"
                  );
                }
              });
          }
        });
    },

    listar() {
      this.$api
        .get(`pagamentos/dados-pagamento`)
        .then((response) => {
          if (response.status == 200) {
            this.tabela.items = [];
            response.data.dados.forEach((element) => {
              element.conta =
                element.numero_conta + " - " + element.descricao_conta;
              this.tabela.items.push(element);
            });
            this.tabela.totalRows = response.data.dados.length;
          }
        })
        .catch((error) => {
          if (error.response.data) {
            this.$helpers.showToast(
              this,
              "Erro",
              error.response.data.message,
              "danger"
            );
          }
        });
    },
  },

  mounted() {
    this.listar();
  },
};
</script>

<style scoped>
</style>
